import { ConfirmBoxDefaultButton } from "./confirm-box.component";

export class ConfirmBoxModel {
    lblTitle?: string;
    lblSubtitle?: string;
    lblConfirmButton?: string = 'Confirmar';
    lblCancelButton?: string = 'Cancelar';
    color?: string = '#5AB8CA';
    onConfirm?: Function;
    onCancel?: Function;
    defaultButton?: ConfirmBoxDefaultButton = ConfirmBoxDefaultButton.cancelar;
    showCancelButton?: boolean = true;

    constructor() { }
}